var MOBILE_BREAKPOINT = 739;
var getChannel = function (secondLevelDomain) {
    return window.innerWidth <= MOBILE_BREAKPOINT &&
        secondLevelDomain.includes('xing.com')
        ? 'webm'
        : 'web';
};
export default getChannel;
